import axios from 'axios'
import store from '../store/index'
import router from '../router'

const d_url = obj => {
    if (typeof obj == 'undefined') { return '' }
    const params = []
    Object.keys(obj).forEach((key) => {
        let value = obj[key]
        if (typeof value !== 'undefined' || value !== null) {
            params.push([key, encodeURIComponent(value)].join('='))
        }
    })
    return '?' + params.join('&')
}
axios.interceptors.request.use(config => {  //请求拦截器
    if (config.url.indexOf('127.0.0.1') < 0){
        store.state.token && (config.headers.Authorization = store.state.token)
    }else{
        config.baseURL = ''
    }
    return config
})
axios.interceptors.response.use(response => {   //响应拦截器
    response.data && response.data.token && (store.commit('settoken', response.data.token) || sessionStorage.setItem("token", JSON.stringify(response.data.token)))
    if (response.data) {
        if (response.data.code) {
            return Promise.resolve(response.data)
        } else {
            if (response.data.msg) {
                switch (response.data.msg) {
                    case "权限不足":
                        response.data.msg = "权限不足,请重新登录！"
                        router.replace('/logout')
                        break;
                    case "token contains an invalid number of segments":
                        response.data.msg = "用户认证失败,请重新登录！"
                        router.replace('/logout')
                        break;
                    default:
                        if (response.data.msg.indexOf('token is expired by ') != -1) {
                            response.data.msg = "操作超时,请重新登录！"
                            router.replace('/logout')
                        }
                        break;
                }
            }
        }
    }
    return Promise.reject(response.data)
})
axios.defaults.baseURL = 'https://hgz.api.sdmxty.cn/'     //设置默认请求地址
axios.defaults.headers['Content-Type'] = 'application/json;charset=UTF-8'    //设置默认请求头

const api = {}
api.facelogin = d => axios.post('front/facelogin', d)
api.faceybdel = d => axios.get('users/faceybdel' + d_url(d))
api.faceybadd = d => axios.post('users/faceybadd', d)


api.login = d => axios.post('front/login', d)
api.register = d => axios.post('front/register', d)
api.isHasUser = d => axios.post('front/ishasuser', d)
// api.getOpenId = d => axios.get('front/getopenid' + d_url(d))
api.getCaptchaForEmail = d => axios.get('front/getcaptchaforemail' + d_url(d))
api.reSetPasswordForEmail = d => axios.post('front/resetpasswordforemail', d)
api.getConfig = d => axios.get('front/getconfig' + d_url(d))

api.upImg = d => axios.post('upload/img', d, { headers: { 'Content-Type': 'multipart/form-data' } })
api.delFile = d => axios.get('upload/delfile' + d_url(d))

api.getRoles = d => axios.get('roles/getall' + d_url(d))
api.addRole = d => axios.post('roles/add', d)
api.editRole = d => axios.post('roles/edit', d)
api.delRole = d => axios.get('roles/del' + d_url(d))
api.getRolesAndPolicys = d => axios.get('roles/getroutesandpolicys' + d_url(d))

api.getUsers = d => axios.get('users/getall' + d_url(d))
api.addUser = d => axios.post('users/add', d)
api.editUser = d => axios.post('users/edit', d)
api.delUser = d => axios.get('users/del' + d_url(d))
api.editMyInfo = d => axios.post('users/editmy', d)
api.editUserAdmin = d => axios.post('users/edituseradmin', d)
api.setUserStatus = d => axios.post('users/setstatus', d)
api.reSetPassword = d => axios.post('users/resetpassword', d)

api.getConfigs = d => axios.get('config/getall' + d_url(d))
api.addConfig = d => axios.post('config/add', d)
api.editConfig = d => axios.post('config/edit', d)
api.delConfig = d => axios.get('config/del' + d_url(d))

api.getLogs = d => axios.get('log/getall' + d_url(d))
api.delLog = d => axios.get('log/del' + d_url(d))

api.getMenus = d => axios.get('menus/getall' + d_url(d))
api.addMenu = d => axios.post('menus/add', d)
api.editMenu = d => axios.post('menus/edit', d)
api.delMenu = d => axios.get('menus/del' + d_url(d))

api.getMyMenus = d => axios.get('menus/getallmy' + d_url(d))

api.getLeibies = d => axios.get('hgzleibie/getall' + d_url(d))
api.addLeibie = d => axios.post('hgzleibie/add', d)
api.editLeibie = d => axios.post('hgzleibie/edit', d)
api.delLeibie = d => axios.get('hgzleibie/del' + d_url(d))

api.getProducts = d => axios.get('hgzproduct/getall' + d_url(d))
api.addProduct = d => axios.post('hgzproduct/add', d)
api.editProduct = d => axios.post('hgzproduct/edit', d)
api.delProduct = d => axios.get('hgzproduct/del' + d_url(d))

api.getMyPiCis = d => axios.get('hgzpici/getallmy' + d_url(d))
api.delMyPiCi = d => axios.get('hgzpici/delmy' + d_url(d))
api.addMyPiCi = d => axios.post('hgzpici/addmy', d)
api.editMyPiCi = d => axios.post('hgzpici/editmy', d)

api.getPiCis = d => axios.get('hgzpici/getall' + d_url(d))
api.editPiCi = d => axios.post('hgzpici/edit', d)
api.delPiCi = d => axios.get('hgzpici/del' + d_url(d))

api.isHasPiCi = d => axios.post('hgzpici/ishaspici', d)

api.getMyJiLus = d => axios.get('hgzjilu/getallmy' + d_url(d))
api.addMyJiLu = d => axios.post('hgzjilu/addmy', d)
api.editMyJiLu = d => axios.post('hgzjilu/editmy', d)
api.delMyJiLu = d => axios.get('hgzjilu/delmy' + d_url(d))

api.getJiLus = d => axios.get('hgzjilu/getall' + d_url(d))
api.editJiLu = d => axios.post('hgzjilu/edit', d)
api.delJiLu = d => axios.get('hgzjilu/del' + d_url(d))

api.getHgzs = d => axios.get('hgzhgz/getall' + d_url(d))
api.delHgz = d => axios.get('hgzhgz/del' + d_url(d))
api.activeAllHgz = d => axios.post('hgzhgz/activeall', d)
api.activeSelectHgz = d => axios.get('hgzhgz/activeselect' + d_url(d))
api.setHgzStatus = d => axios.post('hgzhgz/setstatus', d)

api.getMyHgzs = d => axios.get('hgzhgz/getallmy' + d_url(d))
api.delMyHgz = d => axios.get('hgzhgz/delmy' + d_url(d))
api.addMyHgz = d => axios.post('hgzhgz/addmy', d)

api.getMyRatings = d => axios.get('hgzrating/getallmy' + d_url(d))
api.getRatings = d => axios.get('hgzrating/getall' + d_url(d))
api.delRating = d => axios.get('hgzrating/del' + d_url(d))
// api.editRating = d => axios.post('hgzrating/edit', d)
api.addRating = d => axios.post('front/addrating', d)

api.getFazhengs = d => axios.get('hgzfazheng/getall' + d_url(d))
api.addFazheng = d => axios.post('hgzfazheng/add', d)
api.delFazheng = d => axios.get('hgzfazheng/del' + d_url(d))

api.hgzChaYan = d => axios.get('front/chayan' + d_url(d))

api.getCounts = d => axios.get('hgzcount/getall' + d_url(d))

export default api